<template>
    <v-row>
        <v-col>
            <v-skeleton-loader v-if="props.loading"></v-skeleton-loader>

            <v-card v-else>
                <v-data-table
                    :custom-filter="filterAction"
                    :headers="headers"
                    :item-value="(item: any) => `${item.createdAt}`"
                    :items="props.auditEvents"
                    :items-per-page-options="DefaultPerPageOptions"
                    :search="filter"
                    items-per-page="10"
                    show-expand
                >
                    <template #header.action="{ column }">
                        <v-select
                            v-model="filter"
                            :items="selectItems"
                            :label="column.title"
                            class="filter-select"
                            variant="underlined"
                        ></v-select>
                    </template>
                    <template #item.createdAt="{ item }">
                        {{ formatDate(item.createdAt) }}
                    </template>
                    <template #expanded-row="{ item }">
                        <td></td>
                        <td class="expand-content" colspan="3">
                            <pre>{{ formatJson(item.jsonData) }}</pre>
                        </td>
                    </template>
                </v-data-table>
            </v-card>
        </v-col>
    </v-row>
</template>

<script lang="ts" setup>
import { VDataTable, VSkeletonLoader } from 'vuetify/components';
import { useFormatters } from '@/features/shared/formatters';
import { ref } from 'vue';
import { AuditEvent, AuditEventAction } from '@/features/auditing/auditingModels';
import { DefaultPerPageOptions } from '@/features/shared/models';

interface Props {
    auditEvents: Array<AuditEvent>;
    loading: boolean;
}

const props = defineProps<Props>();
const formatters = useFormatters();

const filterPlaceholder = 'Alle';
const filter = ref(filterPlaceholder);
const selectItems = [
    filterPlaceholder,
    AuditEventAction[AuditEventAction.View],
    AuditEventAction[AuditEventAction.Create],
    AuditEventAction[AuditEventAction.Update]
];

const headers = [
    {
        title: '',
        key: 'data-table-expand',
        width: '1%'
    },
    {
        title: 'Dato',
        key: 'createdAt',
        sortable: true,
        firstSortType: 'desc',
        width: '250px'
    },
    {
        title: 'Handling',
        key: 'action',
        width: '250px'
    },
    {
        title: 'Bruker',
        key: 'user',
        sortable: true
    }
];

function filterAction(value: string, query: string) {
    if (query === filterPlaceholder) return true;
    return value === query;
}

function formatDate(date: Date) {
    return formatters.toLocaleDateTime(date);
}

function formatJson(json?: string) {
    if (!json) return '';
    return JSON.stringify(JSON.parse(json), null, '\t');
}
</script>

<style class="scss" scoped>
.expand-content {
    padding: 12px;
}

.filter-select {
    margin: 10px 0;
}

.filter-select :deep(.v-input__details) {
    display: none;
}
</style>
